import React, {useEffect, useState} from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Grid,
  DialogActions,
} from '@material-ui/core';
import FilterAutoComplete from "../../shared/FilterAutoComplete";

const TeamLocationMerger = ({open, close, body, team, teams, handleManageLocation, ...props}) => {
  const [primaryTeam, setPrimaryTeam] = useState({
    id: team?.id,
    name: `${team?.team_name} ${team?.crd_id ? "(" + team?.crd_id + ")" : ""}`
  });
  const [teamsToMerge, setTeamsToMerge] = useState([]);
  const teamsToMergeOptions = [
    ...teams?.map(({id, team_name, crd_id}) => ({
      id,
      name: `${team_name} ${crd_id ? "(" + crd_id + ")" : ""}`
    })),
  ];

  useEffect(() => {
    setPrimaryTeam({
      id: team?.id,
      name: `${team?.team_name} ${team?.crd_id ? "(" + team?.crd_id + ")" : ""}`
    })
  }, [team]);

  const onTeamsChange = (value) => {
    setTeamsToMerge(value);
  }

  const onMerge = async (event) => {
    event.persist();
    event.preventDefault();

    if (window.confirm(`You are about to add location from ${primaryTeam.name} into ${teamsToMerge.map(({name}) => name).join(", ")}. Are you sure you'd like to proceed?`)) {
      handleManageLocation(primaryTeam, teamsToMerge, 'merge');
      close();
    }
  }

  const onClose = () => {
    close();
  }

  return <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="form-dialog-title"
      fullWidth
      className={"dialog"}
      maxWidth={"md"}
  >
    <DialogTitle id="form-dialog-title" disableTypography>
      <h4 className={"dialog-title"}>Merge Location Groups</h4>
    </DialogTitle>
    <DialogContent dividers>
      <DialogContentText>
        {body}
      </DialogContentText>

      <Grid container spacing={3}>
        <Grid item xs={6}>
          <FilterAutoComplete
              options={teamsToMergeOptions || []}
              handleOnChange={(value) => onTeamsChange(value)}
              selected={teamsToMerge}
              multiple={true}
              label={'Groups to add Location'}
              field={'teams'}
          />
        </Grid>
      </Grid>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Close</Button>
      <Button color="primary" variant="contained" onClick={onMerge}>Merge Location</Button>
    </DialogActions>
  </Dialog>
}

export default TeamLocationMerger;